import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useTheme } from '../../../../../theme';
import { getMiscServiceGroups } from '../../../store/order/selectors';
import CardExtra, { CheckinCardExtrasProvider } from '../../../../../CardExtra';

import { useCardExtraServices } from '@entities/order/service';

const AdditionalServices = () => {
	const { AdditionalServices: theme } = useTheme('Checkin');
	const { t } = useTranslation('Checkin');

	const { cartExtraServicesByTypes, availableCardExtraServices } = useCardExtraServices();
	const miscServiceGroups = useSelector(getMiscServiceGroups);

	return (
		<CheckinCardExtrasProvider>
			<div className={theme.container}>
				<div className={theme.title}>{t('Anything else?')} </div>
				<div className={theme.services}>
					<CardExtra type="insurance" />
					{availableCardExtraServices.BusinessLounge && (
						<>
							{Object.keys(cartExtraServicesByTypes.BusinessLounge).map(rfisc => (
								<CardExtra
									key={rfisc}
									type="business-lounge"
									filter={{ param: 'rfisc', values: [rfisc] }}
								/>
							))}
						</>
					)}
					<CardExtra type="priority-boarding" />
					{miscServiceGroups.map(group => (
						<CardExtra key={group.key} {...group} type="misc" />
					))}
				</div>
			</div>
		</CheckinCardExtrasProvider>
	);
};

export default AdditionalServices;
